import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResultsConfigComponent } from './components/admin/results-config/results-config.component';
import { BrandsStepComponent } from './components/brands-step/brands-step.component';
import { NeedToRunStepComponent } from './components/need-to-run-step/need-to-run-step.component';
import { PrimaryUseStepComponent } from './components/primary-use-step/primary-use-step.component';
import { ResultsStepComponent } from './components/results-step/results-step.component';
import { StartStepComponent } from './components/start-step/start-step.component';
import { UseCaseStepComponent } from './components/use-case-step/use-case-step.component';

const routes: Routes = [
  {
    path: "start",
    component: StartStepComponent
  },
  {
    path: "primary-use",
    component: PrimaryUseStepComponent
  },
  {
    path: "need-to-run",
    component: NeedToRunStepComponent
  },
  {
    path: "use-case",
    component: UseCaseStepComponent
  },
  {
    path: "brands",
    component: BrandsStepComponent
  },
  {
    path: "results",
    component: ResultsStepComponent
  },
  {
    path: "results-config",
    component: ResultsConfigComponent
  },
  {path: "**", redirectTo: "start", pathMatch: "full"}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
